<Row>
  <Column class="mb-07" md={4}>
    <Toggle
      loaded={loaded(customer)}
      labelText="Zahlungserinnerungen via E-Mail"
      labelA="Keine Zahlungserinnerungen via E-Mail"
      labelB="Zahlungserinnerungen via E-Mail"
      name="electronic_dunning"
      toggled={customer.electronic_dunning}
      on:change={publish}
    />
  </Column>
  <Column class="mb-07" md={4}>
    <TextInput
      model={customer}
      name="electronic_dunning_address"
      on:change={publish}
      labelText="E-Mail-Adresse für Zahlungserinnerungen"
      disabled={!electronic_dunning}
      {errors}
    />
  </Column>
</Row>

<script lang="ts">
  import type { AttrErrors, Customer } from '../models'
  import TextInput from '../form/model/TextInput.svelte'
  import Toggle from '../form/Toggle.svelte'
  import { Row, Column } from 'carbon-components-svelte'
  import { createEventDispatcher, onMount } from 'svelte'
  import { loaded } from '../helper'
  import { extractData } from '../event'

  export let customer: Customer
  export let errors: AttrErrors
  let electronic_dunning: boolean
  let electronic_dunning_address: string

  const dispatch = createEventDispatcher()

  const publish = event => {
    const data = extractData(event)
    const changedCustomer = { id: customer.id, ...data }

    Object.entries(data).forEach(([name, value]) => {
      if (name === 'electronic_dunning') {
        electronic_dunning = value
        if (!value && electronic_dunning_address === '') {
          changedCustomer['electronic_dunning_address'] = null
        }
      }

      if (name === 'electronic_dunning_address') {
        electronic_dunning_address = value
        changedCustomer['electronic_dunning'] = electronic_dunning
      }
    })

    dispatch('change', { customer: changedCustomer })
  }

  onMount(() => {
    electronic_dunning = customer.electronic_dunning
  })
</script>
